module.exports = __webpack_public_path__ + "img/modules-outdoor.d6a73109.jpg";